import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SITE } from "@/lib/api";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/products", label: "Products & Services" },
  { to: "/activities", label: "Activities" },
  { to: "/gallery", label: "Gallery" },
  { to: "/partners", label: "Partners" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-border" data-testid="site-navbar">
      {/* Top strip */}
      <div className="bg-primary text-primary-foreground text-xs hidden md:block">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-between">
          <span className="tracking-wide">Farmers Producer Company | Indapur, Pune, Maharashtra</span>
          <a
            href={`tel:${SITE.phone.replace(/\s/g, "")}`}
            className="inline-flex items-center gap-2 hover:text-accent transition-colors"
            data-testid="nav-top-phone"
          >
            <Phone className="w-3.5 h-3.5" />
            {SITE.phone}
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img
            src="/logo.png"
            alt="Indapur FPC Logo"
            className="w-14 h-14 object-contain shrink-0"
          />
          <div className="leading-tight">
            <div className="font-bold text-primary text-xl tracking-tight" style={{ fontFamily: "Outfit" }}>
              INDAPUR FPC
            </div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
              Farmers Producer Company
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s|&/g, "-")}`}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                  isActive ? "text-primary bg-secondary" : "text-foreground hover:text-primary hover:bg-secondary/50"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Button asChild className="rounded-full bg-primary hover:bg-primary/90 px-5" data-testid="nav-enquiry-btn">
            <Link to="/contact">
              Enquiry Now <ArrowRight className="w-4 h-4 ml-1" />
            </Link>
          </Button>
        </div>

        <button
          className="lg:hidden p-2 rounded-md hover:bg-secondary"
          onClick={() => setOpen((s) => !s)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-border bg-white" data-testid="nav-mobile-menu">
          <div className="px-4 py-3 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2.5 text-sm font-medium rounded-lg ${
                    isActive ? "text-primary bg-secondary" : "text-foreground hover:bg-secondary/50"
                  }`
                }
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s|&/g, "-")}`}
              >
                {l.label}
              </NavLink>
            ))}
            <Button asChild className="rounded-full bg-primary hover:bg-primary/90 mt-2" data-testid="nav-mobile-enquiry-btn">
              <Link to="/contact" onClick={() => setOpen(false)}>
                Enquiry Now
              </Link>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
